# TODO - use yarn for this later
JSZip = require('../../../../../../../vendor/assets/javascripts/v2/jszip')

moduleViewApp.controller('itemImportCtrl', ['$scope', '$filter', '$routeParams', '$timeout', '$q', '$location', 'FileReader', 'ItemUploader', 'MediaUploader', 'SentenceConverter', 'CSVParser', 'itemsContentService', 'moduleContextService', 'myPartnersService', 'PartnerTagUploadService', ($scope, $filter, $routeParams, $timeout, $q, $location, FileReader, ItemUploader, MediaUploader, SentenceConverter, CSVParser, itemsContentService, moduleContextService, myPartnersService, PartnerTagUploadService) ->
  # debug
  window.debug = window.debug || {}
  window.debug["itemImportCtrl"] = $scope
  SUPPORTED_TEMPLATE_TYPES = ['association_collection', 'vocabulary', 'question_and_answer']

  _.assignIn $scope,
    items: []
    editors: {}
    defaultTemplateType: 'association_collection'
    fields:
      anchor:
        text_html: true
      association:
        text_html: true
    csv:
      raw: ""
      template_type: "association_collection"
    mediaMapping: {}
    parseErrors: []
    uploadErrors: []
    itemImporterDirty: false

    setTemplate: (template) ->
      $scope.csv.template_type = template
      for item in $scope.items
        item.template_type = template

    itemIsValid: (item) ->
      item ||= $scope.item
      ($filter('presence')(item.anchor.text_html) || item.anchor.image || item.anchor.sound) &&
        _.every(item.associations, (association) -> ($filter('presence')(association.text_html) || association.sound || association.sound))

    focusTextarea: (type) ->
      $timeout ->
        editor = $scope.editors[type]
        editor && editor.focus()

    onEnterKey: (modelAttr) ->
      # not sure how to set these in the controller when the child directives are fully formed
      if _.isEmpty($scope.editors)
        $scope.editors["anchor"] = angular.element('cg-wysiwyg[model="item.anchor.text_html"] .ql-editor')[0]
        $scope.editors["association"] = angular.element('cg-wysiwyg[model="item.associations[0].text_html"] .ql-editor')[0]

      if modelAttr == "item.anchor.text_html"
        $scope.focusTextarea("association")
      else
        $scope.addItem()

    resetItem: ->
      $scope.item =
        anchor: {}
        associations: [{}]
        template_type: $scope.defaultTemplateType

      $scope.$broadcast "imageUploader:reset"
      $scope.focusTextarea("anchor")

    addItem: ->
      $scope.items.unshift $scope.item
      $scope.resetItem()

    deleteItem: (item) ->
      $scope.items = _.without($scope.items,item)

    uploadItems: ->
      $scope.dirty = true
      $scope.progressMessage = $filter("translate")("js.module_view.item_import.upload_progress_message")
      ItemUploader.upload($scope.set, $scope.items).then (success) ->
        if success.series_id
          $location.url(Packs.iKnowRoutes.v2_create_series_path(success.series_id))
        else
          $scope.items = []
          itemsContentService.reset()
          $location.url Packs.iKnowRoutes.v2_create_set_path($scope.set.id)
      , (error) ->
        $scope.dirty = false
        $scope.progressMessage = null
      , (notify) ->
        $scope.progressMessage = $filter("translate")("js.module_view.item_import.upload_notify_message", items_processed: notify.items_processed, items_total: notify.items_total)

    setTemplateType: (templateType) ->
      $scope.defaultTemplateType = $scope.item.template_type = templateType

    toggleField: (object, field) ->
      $scope.fields[object][field] = !$scope.fields[object][field]

    parseAndInterpolateCSV: ->
      $scope.parseCSV().then (items) ->
        $scope.interpolateMedia()
        $scope.validateItems()

    parseCSV: ->
      $scope.parseErrors = []
      CSVParser($scope.csv.raw).parse().then (items) ->
        for item in items
          item.template_type ||= $scope.csv.template_type
          unless _.includes(SUPPORTED_TEMPLATE_TYPES, item.template_type)
            $scope.parseErrors.push({message: "Item type #{item.template_type} unrecognized. Please use #{SUPPORTED_TEMPLATE_TYPES.join(", ")}."})
        $scope.items = items
      , (errors) ->
        for error in errors
          if _.isString(error)
            $scope.parseErrors.push
              message: error
          else
            $scope.parseErrors.push error
        $scope.items = []

    onMediaUploadProgress: (progress) ->
      console.log progress

    uploadMediaBlob: (file, fileName, type) ->
      deferred = $q.defer()

      MediaUploader({ file: file }, type, $scope.onMediaUploadProgress, fileName)
        .success (json) ->
          $scope.mediaMapping[fileName] = json.response[type]
          deferred.resolve(fileName)
        .error (err) ->
          $scope.uploadErrors.push "Error uploading #{type} '#{fileName}' (#{err})"
          deferred.reject(err)
          console.log(err)

      deferred.promise

    uploadMedia: (zip) ->
      deferred = $q.defer()
      deferredCount = 0

      for zipEntry, index in zip.file(/^((?!__MACOSX).)*$/)
        if $scope.isValidImageFile(zipEntry.name)
          deferredCount++
          $scope.uploadMediaBlob(new Blob([zipEntry.asUint8Array()], { type: "image/" + zipEntry.name.match(/\.([A-Za-z0-9]+)$/).pop() }), zipEntry.name.split('/').pop(), "image")
            .then (success) ->
              deferredCount--
              deferred.resolve() if deferredCount == 0
            , deferred.reject
        else if $scope.isValidSoundFile(zipEntry.name)
          deferredCount++
          $scope.uploadMediaBlob(new Blob([zipEntry.asUint8Array()], { type: "audio/" + zipEntry.name.match(/\.([A-Za-z0-9]+)$/).pop() }), zipEntry.name.split('/').pop(), "sound")
          .then (success) ->
            deferredCount--
            deferred.resolve() if deferredCount == 0
          , deferred.reject

      deferred.resolve() if deferredCount == 0
      deferred.promise

    isValidURI: (uri) ->
      try
        new URL(uri)
        true
      catch
        false

    isValidImageFile: (fileName) ->
      fileName.toLowerCase().match(/^.*\.(gif|jpg|jpeg|jpe|png|svg|svgz|tif|tiff|ico|bm|bmp|webp)$/) != null

    isValidSoundFile: (fileName) ->
      fileName.toLowerCase().match(/^.*\.(aif|aifc|aiff|m2a|mp2|mp3|mpa|mpg|mpga|wav|ogg|mid|midi|kar)$/) != null

    interpolateMedia: ->
      interpolateField = (obj, itemLocation) ->
        return unless obj

        if _.isString(obj.image) && $filter('presence')(obj.image)
          if $scope.isValidImageFile(obj.image) && $scope.mediaMapping[obj.image]
            obj.image = $scope.mediaMapping[obj.image]
          else if $scope.isValidURI(obj.image)
            obj.image =
              url: obj.image
          else
            $scope.uploadErrors.push "Image for #{itemLocation} is invalid: '#{obj.image}'"

        if _.isString(obj.sound) && $filter('presence')(obj.sound)
          if $scope.isValidSoundFile(obj.sound) && $scope.mediaMapping[obj.sound]
            obj.sound = $scope.mediaMapping[obj.sound]
          else if $scope.isValidURI(obj.sound)
            obj.sound =
              url: obj.sound
          else
            $scope.uploadErrors.push "Sound for #{itemLocation} is invalid: '#{obj.sound}'"

      for item, index in $scope.items
        itemLocation = "item #{index + 1}"
        interpolateField(item.anchor, "#{itemLocation} anchor")
        for association, subIndex in (item.associations || [])
          interpolateField(association, "#{itemLocation} association #{subIndex + 1}")
          for distractor, subIndex in (association.distractors || [])
            interpolateField(distractor, "#{itemLocation} association distractor #{subIndex + 1}")
        interpolateField(item.notes, "#{itemLocation} notes")
        for sentence, subIndex in (item.sentences || [])
          interpolateField(sentence, "#{itemLocation} sentence #{subIndex + 1}")
        for subIndex, distractor of (item.anchor.distractors || {})
          interpolateField(distractor, "#{itemLocation} anchor distractor #{subIndex + 1}")

    isValidConcept: (concept) ->
      $filter('presence')(concept.text_html) || _.isObject(concept.image) || _.isObject(concept.sound)

    isValidSentence: (sentence, anchor) ->
      formattedSentence = SentenceConverter.text2html(sentence.text_html, anchor.text_html)
      if $filter('presence')(sentence.text_html) && sentence.text_html != formattedSentence
        sentence.text_html = formattedSentence
      else
        false

    validateItems: ->
      for item, index in $scope.items
        unless $scope.isValidConcept(item.anchor)
          $scope.uploadErrors.push "Anchor for item #{index + 1} requires at least one of text, image, or sound"
        if item.associations
          for association, subIndex in item.associations
            unless $scope.isValidConcept(association)
              $scope.uploadErrors.push "Association #{subIndex + 1} for item #{index + 1} requires at least one of text, image, or sound"
        if item.sentences
          for sentence, subIndex in _.values(item.sentences)
            unless $scope.isValidSentence(sentence, item.anchor)
              $scope.uploadErrors.push "Sentence #{subIndex + 1} for item #{index + 1} must either contain the anchor_text or specify the anchor like *this*"
        if item.sentences && _.toPairs(item.sentences).length > 0
          item.template_type = "vocabulary"

    fetchTags: () ->
      if myPartnersService.currentProductPartner?.id
        PartnerTagUploadService.initialize()

    fetchSet: () ->
      moduleContextService.fetchModule($routeParams.set_id, 'set').then (module) ->
        $scope.set = module

    uploadFile: (file) ->
      $scope.$apply ->
        $scope.csv.raw = null
        $scope.uploadErrors = []

        if file.type == "text/csv" || file.type == "text/plain" || file.name.match(/\.csv$/)
          FileReader.readAsText(file).then (result) ->
            # Step 1: parse CSV
            $scope.csv.raw = result
            $scope.parseAndInterpolateCSV()
        else if file.type == "application/zip" || file.name.match(/\.zip$/)
          FileReader.readAsArrayBuffer(file).then (result) ->
            zipFile = new JSZip()
            zipFile.load(result)

            # grab csv first to fill out preview
            csvFile = zipFile.file(/^((?!__MACOSX).)*csv|txt$/)[0]
            if csvFile
              # Step 1: parse CSV
              $scope.csv.raw = csvFile.asText()
              $scope.parseCSV().then (items) ->
                # Step 2: upload media
                $scope.uploadMedia(zipFile).then ->
                  # Step 3: interpolate media
                  $scope.interpolateMedia()

                  # Step 4: validations
                  $scope.validateItems()
            else
              $scope.uploadErrors.push "Please include one .csv or .txt in your zip file"
        else
          $scope.uploadErrors.push "Only .csv, .txt, or .zip uploads are supported"

  $scope.resetItem()
  $scope.fetchSet()
  myPartnersService.initialize().then () ->
    $scope.fetchTags()

  $scope.$on '$routeChangeSuccess', ($event, current, previous) ->
    $scope.itemMode = current.locals.$itemMode
])
